import { getUrlParam } from '../store/helpers';
import { da } from './da';
import { de } from './de';
import { en } from './en';
import { no } from './no';
const translations = { da, de, en, no };
export const getTranslation = (language = getUrlParam('lang') ?? 'en') => translations[language] ?? en;
